import { useState } from "react";
import BreakingNews from "../../components/BreakingNews";
import Profilecard from "../../components/Profilecard";
import NewsCard from "../../components/NewsCard";
import LatestStories from "../../components/LatestStories";
import useNews from "../../hooks/useNews";
import AdBanner from "../../components/AdBanner";

const PER_PAGE = 6;

const NewsPage = ({
  language,
  state,
  category,
  categoryAliases = [],
  includeEmptyCategory = false,
  staticData = [],
}) => {
  const hasAliases =
    Array.isArray(categoryAliases) && categoryAliases.length > 0;
  const { news: adminNews, loading } = useNews(
    hasAliases ? { language, state } : { language, state, category }
  );
  const { news: mpNewsDynamic } = useNews({ state: "madhyapradesh" });

  const [visibleCount, setVisibleCount] = useState(PER_PAGE);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + PER_PAGE);
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL.replace("/api/v1/", "");

  const normalizedAliases = hasAliases
    ? categoryAliases.map((c) => c.toLowerCase().trim())
    : [];
  const filteredNews = hasAliases
    ? adminNews.filter((item) => {
        const itemCategory = (item.category || "").toLowerCase().trim();
        if (includeEmptyCategory && !itemCategory) return true;
        return normalizedAliases.includes(itemCategory);
      })
    : adminNews;

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <BreakingNews />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-1">
        {/* LEFT */}
        <div className="lg:col-span-9 space-y-12">
          {/* DYNAMIC NEWS */}
          {loading && <p>Loading news...</p>}

          {!loading && adminNews.length === 0 && (
            <p>No news found.</p>
          )}

          {!loading &&
            filteredNews
              .slice(0, visibleCount)
              .map((item) => (
                <Profilecard key={item.id} data={item} />
              ))}

          {/* SHOW MORE BUTTON */}
          {visibleCount < filteredNews.length && (
            <div className="text-center">
              <button
                onClick={handleLoadMore}
                className="px-6 py-3 bg-red-600 text-white
                           font-semibold rounded hover:bg-red-700 transition"
              >
                Show More News
              </button>
            </div>
          )}

          {/* OPTIONAL STATIC FALLBACK */}
          {staticData.map((item, i) => (
            <Profilecard key={`static-${i}`} data={item} />
          ))}

          {/* RELATED GRID */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {mpNewsDynamic.slice(0, 3).map((item) => (
              <NewsCard
                key={item.id}
                title={item.news_title}
                image={`${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`}
                category={item.category}
                state={item.state}
                author={item.reporter_name}   // ✅ Correct Field
                reporter_image={
                  item.reporter_image
                    ? `${BASE_URL}/uploads/news/${encodeURIComponent(item.reporter_image)}`
                    : null
                }
                date={new Date(item.createdAt).toLocaleDateString()}
                readTime="2 Min read"
                fullNews={item.description}
                videoUrl={item.youtube_url}
                link={`/news/${item.id}`}
              />
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <aside className="lg:col-span-3">
          <div className="sticky top-[120px] space-y-4">
            <LatestStories />

            <AdBanner />
          </div>
        </aside>
      </div>
    </div>
  );
};

export default NewsPage;
